import classnames from 'classnames';
import React from 'react';

import { SidebarMenuDefinition } from '../../sidebar-menu';
import './SidebarMenuItem.scss';
import { trackWebAppGAEvent } from '../../../../common/helpers/plugins/website-google-analytics';
import { Link } from '@mm/components';
import { selectActiveFacebookPage } from '@mm/state/selectors/facebookPageSelector';
import { useSelector } from 'react-redux';

type Props = {
  menuItem: SidebarMenuDefinition;
  baseUrl: string;
  isActive: boolean;
  onClick?: () => void;
};

const SidebarMenuItem = (props: Props) => {
  const { menuItem, baseUrl, isActive, onClick: onClickProps } = props;
  const facebookPage = useSelector(selectActiveFacebookPage);

  const linkUrl = baseUrl + menuItem.url;
  const menuName = menuItem.name;
  const classList = classnames('sidebar-menu-item', {
    'sidebar-menu-item--active': isActive,
  });

  const onClick = () => {
    trackWebAppGAEvent('click', {
      category: 'navigation',
      label: `navbar_link_${menuItem.name.toLocaleLowerCase()}`,
    });

    onClickProps?.();
  };

  if (!facebookPage?.getemailsActivated && menuItem.id === 'XRAY_ANALYTICS') {
    return null;
  }

  if (menuItem.externalLink) {
    return (
      <div className={classList}>
        <Link
          className="sidebar-menu-item__link"
          href={menuItem.url}
          isBlank
          onClick={onClick}
        >
          {menuItem.icon?.(isActive)}
          {menuName}
        </Link>
      </div>
    );
  }

  return (
    <div className={classList}>
      <Link
        onLinkClick={onClick}
        to={{ pathname: linkUrl, state: menuItem.historyState }}
        className="sidebar-menu-item__link"
      >
        {menuItem.icon?.(isActive)}
        {menuName}
      </Link>
    </div>
  );
};

export default SidebarMenuItem;
